module.exports = "https://static.wmbcdn.com/uniweb/images/e22bf47c2edef98a18b1b5949d804005.svg";